import { motion } from "framer-motion";
import { REFERENCES } from "@/lib/salesData";

/* ProofSection — Prova social com diretrizes e estatísticas de impacto */

const stats = [
  { value: "11+", label: "anos de experiência", note: "do criador na oncologia" },
  { value: "8", label: "módulos clínicos", note: "organizados por tema" },
  { value: "95+", label: "questões de quiz", note: "para fixar o aprendizado" },
  { value: "7", label: "protocolos de emergência", note: "prontos para o plantão" },
];

export function ProofSection() {
  return (
    <section className="py-16 sm:py-20 bg-card/50 border-y border-border overflow-hidden">
      <div className="container max-w-5xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          {/* Diretrizes */}
          <p className="text-xs text-muted-foreground text-center uppercase tracking-widest mb-5 sm:mb-6">
            Conteúdo baseado nas principais diretrizes internacionais
          </p>

          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-10 sm:mb-14">
            {REFERENCES.map((reference, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: index * 0.06 }}
                className="bg-background border border-border rounded-full px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-semibold text-foreground hover:border-accent/50 transition-colors cursor-default"
              >
                {reference}
              </motion.div>
            ))}
          </div>

          <div className="h-px bg-border mb-8 sm:mb-12" />

          {/* Estatísticas em grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6">
            {stats.map((stat, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="text-center bg-card border border-border rounded-2xl p-4 sm:p-5 hover:border-accent/30 transition-colors"
              >
                <div className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-accent font-mono mb-1">
                  {stat.value}
                </div>
                <div className="text-xs sm:text-sm font-semibold text-foreground mb-0.5">
                  {stat.label}
                </div>
                <div className="text-xs text-muted-foreground leading-tight">
                  {stat.note}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
